import api from './api';
import { AxiosResponse } from 'axios';

export interface Notificacao {
    guid: string;
    titulo: string;
    mensagem: string;
    tipoNotificacao: 'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR' | 'SYSTEM' | 'SUBSCRIPTION' | 'ACCOUNT' | 'TASK' | 'REMINDER';
    dataEnvio: string;
    dataLeitura?: string;
    lida: boolean;
    linkAcao?: string;
    textoAcao?: string;
}

export interface NotificacoesResponse {
    content: Notificacao[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
}

class NotificacaoService {
    /**
     * Busca todas as notificações do usuário com paginação
     */
    async buscarNotificacoes(page = 0, size = 20): Promise<NotificacoesResponse> {
        const response: AxiosResponse<NotificacoesResponse> = await api.get(
            `/api/notificacoes?page=${page}&size=${size}`
        );
        return response.data;
    }

    /**
     * Busca apenas as notificações não lidas do usuário
     */
    async buscarNotificacoesNaoLidas(): Promise<Notificacao[]> {
        // const response: AxiosResponse<Notificacao[]> = await api.get('/api/notificacoes/nao-lidas');
        // return response.data;
        return [];
    }

    /**
     * Retorna o contador de notificações não lidas
     */
    async contarNotificacoesNaoLidas(): Promise<number> {
        const response: AxiosResponse<number> = await api.get('/api/notificacoes/contagem-nao-lidas');
        return response.data;
    }

    /**
     * Marca uma notificação específica como lida
     */
    async marcarComoLida(notificacaoId: string): Promise<Notificacao> {
        const response: AxiosResponse<Notificacao> = await api.put(
            `/api/notificacoes/${notificacaoId}/marcar-como-lida`
        );
        return response.data;
    }

    /**
     * Marca todas as notificações do usuário como lidas
     */
    async marcarTodasComoLidas(): Promise<number> {
        const response: AxiosResponse<number> = await api.put('/api/notificacoes/marcar-todas-como-lidas');
        return response.data;
    }

    /**
     * Para administradores: Envia uma notificação para um usuário específico
     */
    async enviarNotificacaoParaUsuario(
        usuarioGuid: string,
        notificacao: Partial<Notificacao>
    ): Promise<Notificacao> {
        const response: AxiosResponse<Notificacao> = await api.post(
            `/api/notificacoes/admin/usuario/${usuarioGuid}`,
            notificacao
        );
        return response.data;
    }

    /**
     * Para administradores: Envia uma notificação para todos os usuários do tenant
     */
    async notificarTodosTenant(notificacao: Partial<Notificacao>): Promise<void> {
        await api.post('/api/notificacoes/admin/tenant', notificacao);
    }

    /**
     * Retorna o ícone apropriado com base no tipo de notificação
     */
    getIconeNotificacao(tipo: string): string {
        switch (tipo) {
            case 'SUCCESS':
                return 'check_circle';
            case 'WARNING':
                return 'warning';
            case 'ERROR':
                return 'error';
            case 'SYSTEM':
                return 'settings';
            case 'SUBSCRIPTION':
                return 'credit_card';
            case 'ACCOUNT':
                return 'person';
            case 'TASK':
                return 'assignment';
            case 'REMINDER':
                return 'alarm';
            case 'INFO':
            default:
                return 'info';
        }
    }

    /**
     * Retorna a cor apropriada com base no tipo de notificação
     */
    getCorNotificacao(tipo: string): string {
        switch (tipo) {
            case 'SUCCESS':
                return 'success.main';
            case 'WARNING':
                return 'warning.main';
            case 'ERROR':
                return 'error.main';
            case 'SYSTEM':
                return 'secondary.main';
            case 'SUBSCRIPTION':
                return 'primary.dark';
            case 'INFO':
            default:
                return 'primary.main';
        }
    }
}

export const notificacaoService = new NotificacaoService();
export default notificacaoService;
